import {appSession} from "../commons";
import {User} from "../commons/models/user";
import {useMemo} from "react";

const useAuth = () => {
    const accessToken = appSession.getAccessToken();
    const user = useMemo(() => {
        return appSession.getUser() as User;
    }, []);
    return {accessToken, user};
}
export default useAuth;